import samplePdf from './sample.pdf'

export const mockPdf = async () => {
    const res = await fetch(samplePdf);
    const arrayBuffer = await res.arrayBuffer();
    return new Blob([arrayBuffer], {type: 'application/pdf'})
}
